import { defineBoot } from '#q-app/wrappers';
import { createI18n } from 'vue-i18n';
import messages from 'src/i18n';
/* eslint-enable @typescript-eslint/no-empty-object-type */
// Get saved locale from localStorage or use default
const savedLocale = localStorage.getItem('locale');
const defaultLocale = savedLocale || 'en-US';
export const i18n = createI18n({
    locale: defaultLocale,
    legacy: false,
    messages,
});
// @ts-ignore
export default defineBoot(({ app }) => {
    // Set i18n instance on app
    app.use(i18n);
});
